import { getBackendUrl } from "@Utils";
import _ from "lodash";
import IssuesStatusGraphTile from "../../cubeComponent/dashboardComponents/IssuesStatusGraph";
import TasksStatusGraphTile from "../../cubeComponent/dashboardComponents/TasksStatusGraph";
import {
  getProjectEstimatesPageUrl,
  getProjectFilesPageUrl,
  getProjectIssuesPageUrl,
  getProjectTasksPageUrl,
  getProjectTransmittalsPageUrl,
  getProjectSettingsPageUrl,
  getProjectWorkspacesListPageUrl,
  getProjectReviewsPageUrl,
  getProjectContractPageUrl,
  getProjectFormsPageUrl,
} from "../../services/utils/helpers";
import EstimateGraphTile from "../../cubeComponent/dashboardComponents/EstimateGraph";
import { formCategories } from "@Helpers";
import { modulesNameSynonymMapper } from "../../services/constants";
import WidgetTableTile from "../../cubeComponent/dashboardComponents/widgetTable";
import ProjectUsersTile from "../../cubeComponent/dashboardComponents/ProjectUsers";
import QuickLinksTile from "../../cubeComponent/dashboardComponents/QuickLinks";
import ProjectCollaborattorsTile from "../../cubeComponent/dashboardComponents/ProjectCollaborattors";
import IconComponent from "../../cubeComponent/icons";
import {
  estimateListUrl,
  getFilesList,
  getTransmittalDataUrl,
  includedProjectsUrl,
  includedUsersUrl,
  spacesDataUrl,
  taskInspectionAndProgressFormUrl,
  tasksListUrl,
} from "../../services/dataManager";
import UserNameTagComponent from "../../cubeComponent/html/UserNameTagComponent";
import css from "../Reviews/Reviews.module.css";
import { reviewStageMapper } from "../Reviews/ReviewsConstants";
import i18n from "@i18n";

const fullNameTemplate = (args) => <UserNameTagComponent id={args.id} />;

const reviewSerialIdTemplate = (args) => `RE - ${args.serialId}`;
const stagetemplate = (stage, wrapperClass) => (
  <div className={`${css[wrapperClass]} ${css[reviewStageMapper[stage].containerClass]} h-7`}>
    <div className={`${css.reviewStageIndicator} ${css[reviewStageMapper[stage].indicatorClass]}`} />
    <p className={css.reviewStatus}>{reviewStageMapper[stage].name}</p>
  </div>
);
const reviewStageTemplate = (args) => stagetemplate(args.reviewStatus, "reviewStageInGrid");

const taskIdTemplate = (args) => `TSK-${String(args.counter).padStart(4, "0")}`;

const fileExtensionName = (props) => {
  if (props["file.resourceType"] != "RESOURCE_TYPE_MERGED_FILE") {
    const extension = props.fileName?.split(".").pop();
    return extension;
  }

  return " ";
};

function ContractStatusTemplate(args, t) {
  if (!args.lockData) {
    return "";
  }
  if (args.lockData?.isLocked) {
    return (
      <span className="flex gap-4 w-full items-center">
        <IconComponent cssClass="h-5" name="Lock" />
        {t("Locked")}
      </span>
    );
  }

  return (
    <span className="flex gap-4 w-full items-center">
      <IconComponent cssClass="h-5" name="Unlock" />
      {t("Un-Locked")}
    </span>
  );
}

const widgetMapper = ({ projectId, layout }) => {
  const { t } = i18n;
  const widgetsList = {
    QuickLinksTile: {
      component: QuickLinksTile,
      title: t("Quick Links"),
      previewImg: "table_QuickLinks",
      isAdded: true,
      selectedData: {
        MyProjectsData: {
          name: window.location.host.includes("dpmsportal")
            ? `All ${modulesNameSynonymMapper.projects}`
            : t("All Projects"),
          icon: "ProjectsIcon",
          path: "/portalSettings/projects",
          isAdded: true,
          module: "FILES",
        },
        AllProjectsData: {
          name: window.location.host.includes("dpmsportal")
            ? `My ${modulesNameSynonymMapper.projects}`
            : t("My Projects"),
          icon: "ProjectsIcon",
          path: "/projects",
          isAdded: true,
          module: "FILES",
        },
        AllTasksData: {
          name: t("All Tasks"),
          icon: "TasksIcon",
          path: "/tasks?byPortal=true",
          isAdded: true,
          module: "TASKS",
        },
        InProgressTasksData: {
          name: t("In Progress Tasks"),
          icon: "TasksIcon",
          path: "/tasks",
          isAdded: true,
          module: "TASKS",
        },
        AllIssuesData: {
          name: t("All Issues"),
          icon: "issues",
          path: "/issuesList?byPortal=true",
          isAdded: true,
          module: "ISSUES",
        },
        AllReviewsData: {
          name: t("All Reviews"),
          icon: "Review",
          path: "/reviews?byPortal=true",
          isAdded: true,
          module: "WORKFLOW",
        },
        PendingIssueesData: {
          name: t("Pending Issues"),
          icon: "issues",
          path: "/issuesList?byPortal=true",
          isAdded: true,
          module: "ISSUES",
        },
        AllTransmittalsData: {
          name: t("All Transmittals"),
          icon: "Transmittals",
          path: "/transmittals?byPortal=true",
          isAdded: true,
          module: "TRANSMITTAL",
        },
        AllContractsData: {
          name: t("All Contracts"),
          icon: "Contracts",
          path: "/contractsList?byPortal=true",
          isAdded: true,
          module: "CONTRACT",
        },
        AllFilesData: {
          name: t("All Files"),
          icon: "files",
          path: "/Files?byPortal=true",
          isAdded: true,
          module: "FILES",
        },
        RecentlyReceivedTransmittalsData: {
          name: t("Recently Received Transmittals"),
          icon: "Transmittals",
          path: "/transmittals?byPortal=true",
          isAdded: true,
          module: "TRANSMITTAL",
        },
        SentTransmittalsData: {
          name: t("Sent Transmittals"),
          icon: "Transmittals",
          path: "/transmittals?byPortal=true",
          isAdded: true,
          module: "TRANSMITTAL",
        },
        AllEstimatesData: {
          name: t("All Estimates"),
          icon: "estimates",
          path: "/estimatePortalList",
          isAdded: true,
          module: "ESTIMATES",
        },
        OrgSettingsData: {
          type: "orgSettings",
          name: t("Org Settings"),
          icon: "SettingsIcon",
          isAdded: true,
          module: "FILES",
        },
        PortalSettingsData: {
          name: t("Portal Settings"),
          icon: "SettingsIcon",
          path: "/portalSettings/users",
          isAdded: true,
          module: "FILES",
        },
        ProfileSettingsData: {
          name: t("Profile Settings"),
          icon: "SettingsIcon",
          path: "/user-profile/personalInformation",
          isAdded: true,
          module: "FILES",
        },
      },
      availableData: [],
      allowIn: ["PORTAL"],
      propertiesOption: [
        { id: "1", text: "Configure" },
        { id: "2", text: "Remove" },
      ],
      layout: {
        w: 12,
        h: 2,
        x: 0,
        y: 0,
      },
    },
    ProjectUsersTile: {
      component: ProjectUsersTile,
      title: window.location.host.includes("dpmsportal")
        ? `${modulesNameSynonymMapper.project} Users`
        : t("Project Users"),
      isAdded: true,
      previewImg: "table_ProjectUsers",
      expand: true,
      module: "FILES",
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
      allowIn: ["PORTAL"],
      layout: {
        w: 9,
        h: 3,
        x: 0,
        y: 2,
      },
    },
    ProjectCollaborattorsTile: {
      component: ProjectCollaborattorsTile,
      title: t("Project Collaborators"),
      isAdded: true,
      previewImg: "table_ProjectCollaborators",
      expand: true,
      module: "FILES",
      allowIn: ["PORTAL"],
      layout: {
        w: 3,
        h: 3,
        x: 10,
        y: 2,
      },
      propertiesOption: [{ id: "", text: "Remove" }],
    },
    ProjectTableTile: {
      component: WidgetTableTile,
      title: window.location.host.includes("dpmsportal") ? `${modulesNameSynonymMapper.projects}` : t("Projects"),
      isAdded: true,
      path: "/projects",
      previewImg: "table_Projects",
      module: "FILES",
      allowIn: ["PORTAL"],
      url: includedProjectsUrl,
      layout: {
        w: 7,
        h: 3,
        x: 0,
        y: 5,
      },
      headers: [
        {
          field: "projectId",
          headerText: window.location.host.includes("dpmsportal")
            ? `${modulesNameSynonymMapper.project} ID`
            : t("Project ID"),
          width: "150",
          textAlign: "Left",
        },
        {
          field: "description",
          headerText: window.location.host.includes("dpmsportal")
            ? `${modulesNameSynonymMapper.project} Name`
            : t("Project Name"),
          width: "300",
          textAlign: "Left",
        },
      ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    EstimateGraphTile: {
      component: EstimateGraphTile,
      title: t("Estimates by Cost Database"),
      isAdded: true,
      previewImg: "table_EstimateByCDB",
      expand: true,
      module: "ESTIMATES",
      allowIn: ["PORTAL"],
      propertiesOption: [
        // { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
      layout: {
        w: 5,
        h: 3,
        x: 7,
        y: 5,
      },
    },
    ContractsTableTile: {
      component: WidgetTableTile,
      title: t("Contracts"),
      path: projectId ? getProjectContractPageUrl(projectId) : "/contractsList?byPortal=true",
      isAdded: true,
      previewImg: "table_Issues",
      url: `${getBackendUrl()}/contracts/contractsController`,
      layout: {
        w: 6,
        h: 3,
        x: 0,
        y: 8,
      },
      headers: [
        {
          field: "title",
          headerText: t("Title"),
          width: "40",
          textAlign: "Left",
        },
        {
          field: "description",
          headerText: t("Description"),
          width: "40",
          textAlign: "Left",
        },
        {
          field: "type",
          headerText: t("Type"),
          width: "40",
          textAlign: "Left",
        },
        {
          field: "isLocked",
          headerText: t("Status"),
          width: "40",
          textAlign: "Left",
          template: (args) => ContractStatusTemplate(args, t),
        },
      ],
      module: "CONTRACT",
      allowIn: ["PROJECT", "PORTAL"],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    IssuesTableTile: {
      component: WidgetTableTile,
      title: t("Issues"),
      previewImg: "table_Issues",
      isAdded: true,
      path: projectId ? getProjectIssuesPageUrl(projectId) : "/issuesList?byPortal=true",
      module: "ISSUES",
      allowIn: ["PROJECT", "PORTAL"],
      url: `${getBackendUrl()}/issues/getIssuesData`,
      layout: {
        w: 6,
        h: 3,
        x: 8,
        y: 8,
      },
      headers: [
        {
          field: "issueCounter",
          headerText: t("ID"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "title",
          headerText: t("Title"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "spaceName",
          headerText: window.location.host.includes("dpmsportal") ? `${modulesNameSynonymMapper.space}` : "Space",
          width: "30",
          textAlign: "Left",
        },
      ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    ReviewsTableTile: {
      component: WidgetTableTile,
      title: t("Reviews"),
      previewImg: "table_Issues",
      isAdded: true,
      path: projectId ? getProjectReviewsPageUrl(projectId) : "/reviews?byPortal=true",
      module: "WORKFLOW",
      allowIn: ["PROJECT", "PORTAL"],
      url: `${getBackendUrl()}/reviews/reviewsService`,
      layout: {
        w: 6,
        h: 3,
        x: 8,
        y: 8,
      },
      headers: projectId
        ? [
            {
              field: "serialId",
              headerText: t("ID"),
              width: "30",
              height: 60,
              textAlign: "Left",
              template: reviewSerialIdTemplate,
            },
            {
              field: "name",
              headerText: t("Name"),
              width: "30",
              height: 60,
              textAlign: "Left",
            },
            {
              field: "spaceName",
              headerText: t("Space"),
              width: "30",
              height: 60,
              textAlign: "Left",
            },
            {
              field: "reviewStatus",
              headerText: t("Stage"),
              width: "30",
              height: 60,
              textAlign: "Left",
              template: reviewStageTemplate,
            },
          ]
        : [
            {
              field: "projectData.projectId",
              headerText: t("Project ID"),
              width: "30",
              textAlign: "Left",
            },
            {
              field: "projectData.description",
              headerText: t("Project Name"),
              width: "30",
              textAlign: "Left",
            },
            {
              field: "serialId",
              headerText: t("Review ID"),
              width: "30",
              textAlign: "Left",
              template: reviewSerialIdTemplate,
            },
            {
              field: "name",
              headerText: t("Review Name"),
              width: "30",
              textAlign: "Left",
            },
            {
              field: "reviewStatus",
              headerText: t("Stage"),
              width: "30",
              textAlign: "Left",
              template: reviewStageTemplate,
            },
          ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    TransmittalsTableTile: {
      component: WidgetTableTile,
      title: t("Transmittals"),
      previewImg: "table_Transmittals",
      isAdded: true,
      path: projectId ? getProjectTransmittalsPageUrl(projectId) : "/transmittals?byPortal=true",
      module: "TRANSMITTAL",
      allowIn: ["PORTAL", "PROJECT"],
      url: getTransmittalDataUrl,
      layout: {
        w: 6,
        h: 3,
        x: 0,
        y: 8,
      },
      headers: [
        {
          field: "transmittalId",
          headerText: t("ID"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "project.name",
          headerText: t("Project Name"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "from",
          headerText: t("From Space"),
          width: "30",
          textAlign: "Left",
        },
      ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    TaskTableTile: {
      component: WidgetTableTile,
      title: t("Tasks"),
      previewImg: "table_Tasks",
      isAdded: true,
      path: projectId ? getProjectTasksPageUrl(projectId) : "/tasks?byPortal=true",
      module: "TASKS",
      allowIn: ["PROJECT", "PORTAL"],
      url: tasksListUrl,
      headers: [
        {
          field: "counter",
          headerText: t("ID"),
          width: "30",
          textAlign: "Left",
          template: taskIdTemplate,
        },
        {
          field: "title",
          headerText: t("Title"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "space.spaceName",
          headerText: t("Space"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "createdBy.fullName",
          headerText: t("Assigned By"),
          width: "50",
          textAlign: "Left",
        },
      ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
      layout: {
        w: 6,
        h: 2,
        x: 0,
        y: 11,
      },
    },
    EstimatesTableTile: {
      component: WidgetTableTile,
      title: t("Estimates"),
      previewImg: "table_Estimates",
      isAdded: true,
      path: projectId ? getProjectEstimatesPageUrl(projectId) : "/estimatePortalList",
      module: "ESTIMATES",
      allowIn: ["PROJECT", "PORTAL"],
      url: estimateListUrl,
      layout: {
        w: 6,
        h: 2,
        x: 7,
        y: 11,
      },
      headers: [
        {
          field: "counter",
          headerText: t("ID"),
          width: "20",
          textAlign: "Left",
        },
        {
          field: "name",
          headerText: t("Title"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "spaceName",
          headerText: t("Space"),
          width: "30",
          textAlign: "Left",
        },
      ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    SpaceTableTile: {
      component: WidgetTableTile,
      title: window.location.host.includes("dpmsportal") ? `${modulesNameSynonymMapper.spaces}` : t("Spaces"),
      previewImg: "table_Spaces",
      isAdded: true,
      path: getProjectWorkspacesListPageUrl(projectId),
      module: "FILES",
      allowIn: ["PROJECT"],
      url: spacesDataUrl,
      headers: [
        {
          field: "spaceName",
          headerText: window.location.host.includes("dpmsportal")
            ? `${modulesNameSynonymMapper.space} Name`
            : t("Space Name"),
          width: "50",
          textAlign: "Left",
        },
      ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    RecentFilesTableTile: {
      component: WidgetTableTile,
      title: t("Recent Files"),
      previewImg: "table_ProjectRecentFiles",
      isAdded: true,
      path: getProjectFilesPageUrl(projectId),
      module: "FILES",
      allowIn: ["PROJECT"],
      url: getFilesList,
      headers: [
        {
          field: "fileName",
          headerText: t("File Name"),
          width: "50",
          textAlign: "Left",
        },
        {
          field: "fileName",
          headerText: t("File Type"),
          width: "50",
          textAlign: "Left",
          template: fileExtensionName,
        },
      ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    UserTableTile: {
      component: WidgetTableTile,
      title: t("Users"),
      previewImg: "table_ProjectRecentFiles",
      isAdded: true,
      path: getProjectSettingsPageUrl({ projectId, tab: "users" }),
      module: "FILES",
      allowIn: ["PROJECT"],
      url: includedUsersUrl,
      headers: [
        {
          field: "fullName",
          headerText: t("User Name"),
          width: "30",
          textAlign: "Left",
          template: fullNameTemplate,
        },
        {
          field: "roleName",
          headerText: t("Project Role"),
          width: "30",
          textAlign: "Left",
        },
      ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    InspectionsTableTile: {
      component: WidgetTableTile,
      title: t("Inspections"),
      previewImg: "table_Tasks",
      isAdded: true,
      path: getProjectFormsPageUrl(projectId, formCategories.inspection),
      resourceType: formCategories.inspection,
      module: formCategories.inspection,
      allowIn: ["PROJECT"],
      url: taskInspectionAndProgressFormUrl,
      headers: [
        {
          field: "counter",
          headerText: t("Form ID"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "title",
          headerText: t("Title"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "spaceName",
          headerText: t("Space"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "createdByData.name",
          headerText: t("Assigned By"),
          width: "50",
          textAlign: "Left",
        },
      ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    progressUpdatesTableTile: {
      component: WidgetTableTile,
      title: t("Progress Updates"),
      previewImg: "table_Tasks",
      isAdded: true,
      path: getProjectFormsPageUrl(projectId, formCategories.progressUpdates),
      resourceType: formCategories.progressUpdates,
      module: formCategories.progressUpdates,
      allowIn: ["PROJECT"],
      url: taskInspectionAndProgressFormUrl,
      headers: [
        {
          field: "counter",
          headerText: t("Form ID"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "title",
          headerText: t("Title"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "spaceName",
          headerText: t("Space"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "createdByData.name",
          headerText: t("Assigned By"),
          width: "50",
          textAlign: "Left",
        },
      ],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    generalFormsTableTile: {
      component: WidgetTableTile,
      title: t("General Forms"),
      previewImg: "table_Tasks",
      isAdded: true,
      path: getProjectFormsPageUrl(projectId, formCategories.generalForms),
      resourceType: formCategories.generalForms,
      module: formCategories.generalForms,
      allowIn: ["PROJECT"],
      url: taskInspectionAndProgressFormUrl,
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
      headers: [
        {
          field: "counter",
          headerText: t("Form ID"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "title",
          headerText: t("Title"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "spaceName",
          headerText: t("Space"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "createdByData.name",
          headerText: t("Assigned By"),
          width: "50",
          textAlign: "Left",
        },
      ],
    },
    permitToWorkTableTile: {
      component: WidgetTableTile,
      title: t("Permit To Work"),
      previewImg: "table_Tasks",
      isAdded: true,
      path: getProjectFormsPageUrl(projectId, formCategories.permitToWork),
      resourceType: formCategories.permitToWork,
      module: formCategories.permitToWork,
      allowIn: ["PROJECT"],
      url: taskInspectionAndProgressFormUrl,
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
      headers: [
        {
          field: "counter",
          headerText: t("Form ID"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "title",
          headerText: t("Title"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "spaceName",
          headerText: t("Space"),
          width: "30",
          textAlign: "Left",
        },
        {
          field: "createdByData.name",
          headerText: t("Assigned By"),
          width: "50",
          textAlign: "Left",
        },
      ],
    },
    IssuesStatusGraphTile: {
      component: IssuesStatusGraphTile,
      title: t("Issues by Status"),
      previewImg: "table_ProjectIssuesByStatus",
      isAdded: true,
      expand: true,
      module: "ISSUES",
      allowIn: ["PROJECT"],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
    TasksStatusGraphTile: {
      component: TasksStatusGraphTile,
      title: t("Tasks by Status"),
      previewImg: "table_ProjectTasksByStatuses",
      isAdded: true,
      expand: true,
      module: "TASKS",
      allowIn: ["PROJECT"],
      propertiesOption: [
        { id: "1", text: "Load Next Data" },
        { id: "", text: "Remove" },
      ],
    },
  };

  if (window.location.host.includes("dpmsportal")) {
    delete widgetsList.IssuesStatusGraphTile;
  }

  const mapper = {};
  const width = 4;
  const height = 2;

  Object.keys(widgetsList).forEach((key, index) => {
    const x = (index % 3) * width;
    const y = Math.floor(index / 3) * height;
    const widget = widgetsList[key];
    if (
      key == "QuickLinksTile" &&
      ((projectId && widget.allowIn.includes("PROJECT")) || (!projectId && widget.allowIn.includes("PORTAL")))
    ) {
      const selectedData = {};
      Object.keys(widgetsList[key].selectedData).forEach((data) => {
        if (_.get(layout, `${widgetsList[key].selectedData[data].module}.ENABLE`)) {
          selectedData[data] = {
            ...widgetsList[key].selectedData[data],
          };
        }
      });
      mapper[key] = {
        ...widgetsList[key],
        selectedData,
        layout: widget.layout,
      };
    } else if (
      _.get(layout, `${widgetsList[key].module}.ENABLE`) &&
      ((projectId && widget.allowIn.includes("PROJECT")) || (!projectId && widget.allowIn.includes("PORTAL")))
    ) {
      const layout = {
        w: width,
        h: height,
        x,
        y,
      };
      mapper[key] = {
        ...widgetsList[key],
        layout: projectId ? layout : widget.layout,
      };
    }
  });
  return mapper;
};

export default widgetMapper;
